import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { selectFleetIds } from '@asset-solutions/customer-portal/auth/data-access';
import { OrderFilters } from '@asset-solutions/customer-portal/orders/models';
import {
  changeOrderFilters,
  resetOrderFilters,
  selectCustomerOptions,
  selectOrdersFilters
} from '@asset-solutions/customer-portal/orders/store';
import { deepCopy } from '@asset-solutions/shared/utilities';
import { PushPipe } from '@ngrx/component';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';

import { FilterFormComponent } from '../filter-form/filter-form.component';

@Component({
  selector: 'orders-filters',
  imports: [PushPipe, FilterFormComponent],
  templateUrl: './order-filters.component.html',
  styleUrls: ['./order-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderFiltersComponent {
  private store = inject(Store);

  protected customerOptions$ = this.store.select(selectCustomerOptions);
  protected filters$ = this.store.select(selectOrdersFilters).pipe(map((filters) => deepCopy(filters)));
  protected fleetOptions$ = this.store.select(selectFleetIds);

  public onFiltersChange(filters: OrderFilters): void {
    this.store.dispatch(changeOrderFilters({ filters }));
  }

  public resetClick(): void {
    this.store.dispatch(resetOrderFilters());
  }
}
